export default __webpack_public_path__ + "static/loader-e721cd9ddbfce3ea08f6ce03b47f430c.gif";